import { render, staticRenderFns } from "./archivos.vue?vue&type=template&id=21974b38&"
import script from "./archivos.vue?vue&type=script&lang=js&"
export * from "./archivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports